import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import api, { fmt } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { StatusBadge } from "./Dashboard";

export default function Campaigns() {
  const [campaigns, setCampaigns] = useState(null);

  useEffect(() => {
    api.get("/client/campaigns").then((r) => setCampaigns(r.data)).catch(() => setCampaigns([]));
  }, []);

  if (!campaigns) return <div className="space-y-4">{[...Array(2)].map((_, i) => <Skeleton key={i} className="h-32 bg-white/5" />)}</div>;

  return (
    <div className="space-y-6" data-testid="campaigns-page">
      <div>
        <p className="section-label">Campaigns</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-white tracking-tight mt-1">Campaign Management</h2>
      </div>

      {campaigns.length === 0 && (
        <div className="card-surface p-14 text-center">
          <Megaphone className="w-10 h-10 mx-auto text-slate-600 mb-3" />
          <p className="text-slate-400">No campaigns yet. Your GEOTRAQ AI team will set up your first campaign.</p>
        </div>
      )}

      <div className="space-y-4">
        {campaigns.map((c) => (
          <Link key={c.id} to={`/portal/campaigns/${c.id}`} data-testid={`campaign-card-${c.id}`}>
            <div className="card-surface p-6 hover:border-cyan-500/30 transition-colors">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <div className="flex items-center gap-3 flex-wrap">
                    <h3 className="font-display font-bold text-white text-lg">{c.name}</h3>
                    <StatusBadge status={c.status} />
                  </div>
                  <p className="text-sm text-slate-400 mt-1.5">
                    {c.start_date} → {c.end_date} · {c.duration_days} days · {c.num_locations} locations · radius up to {fmt(c.max_radius)}m
                  </p>
                  <p className="text-xs text-slate-500 mt-1">Manager: {c.manager} · {c.creative_type} creative</p>
                </div>
                <div className="grid grid-cols-3 sm:grid-cols-5 gap-6 text-right">
                  {[["Impressions", c.metrics?.impressions], ["Reach", c.metrics?.reach], ["Engagements", c.metrics?.engagements], ["Clicks", c.metrics?.clicks]].map(([label, v]) => (
                    <div key={label}>
                      <p className="font-display font-bold text-white">{fmt(v)}</p>
                      <p className="text-[10px] tracking-widest text-slate-500 uppercase">{label}</p>
                    </div>
                  ))}
                  <div>
                    <p className="font-display font-bold text-cyan-300">{c.metrics?.engagement_rate}%</p>
                    <p className="text-[10px] tracking-widest text-slate-500 uppercase">Eng. Rate</p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
